import { invokeApig } from '../libs/awsLib'

export class featureFlagApi {
  static getFeatures (idToken) {
    return invokeApig({ path: '/featureFlags', method: 'GET' }, idToken)
  }

  static updateFeature (feature, idToken) {
    return invokeApig({ path: `/featureFlags/${feature.feature_flag_id}`, method: 'PUT', body: feature }, idToken)
  }

  static deleteFeature (featureId, idToken) {
    return invokeApig({ path: `/featureFlags/${featureId}`, method: 'DELETE' }, idToken)
  }

  static createFeature (newFeature, idToken) {
    return invokeApig({ path: '/featureFlags', method: 'POST', body: newFeature }, idToken)
  }
}
